import { call, takeEvery } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';

import { uploadLogoSuccess } from 'js/reducers/brandKitLogo';

import { track } from '../mixpanelProvider';

function* trackUploadLogo({ payload }: PayloadAction<{ assetId: number; contentType: string; filename: string }>) {
  yield call(track, 'Upload Overlay', {
    'Content Type': payload.contentType,
    Filename: payload.filename
  });
}

export default function* trackBrandKitLogoSaga() {
  yield takeEvery(uploadLogoSuccess.type, trackUploadLogo);
}
